module.exports = __webpack_public_path__ + "img/full4-min.73126d86.png";